/*
  Samonde part number decoders: one engine, one profile per brand.
  The page (sections/part-decoder.liquid) supplies #PartDecoder[data-brand] and a JSON list of
  known prefixes ({p: display prefix, g: group, n: name, d: what it is}). The longest prefix that
  the input starts with wins. A profile only adds what the prefix table cannot express: how the
  brand formats numbers, which spellings to show, how to query stock, and extra details that
  can be read straight off the number (e.g. an Altivar power rating).
  Keep every decoded claim to what the number itself encodes. Anything else belongs in the
  catalogue link or a sourcing request, never in a guess.
*/
(function () {
  var root = document.getElementById('PartDecoder');
  if (!root) return;
  var brand = root.getAttribute('data-brand');
  var data;
  try { data = JSON.parse(document.getElementById('PartDecoderData').textContent); } catch (e) { return; }

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function compact(s) { return String(s || '').toUpperCase().replace(/[\s\-.\/_#:]/g, ''); }
  function tidy(s) { return String(s || '').toUpperCase().replace(/\s+/g, ' ').trim(); }

  data.forEach(function (d) { d.k = compact(d.p); });
  data.sort(function (a, b) { return b.k.length - a.k.length; });

  function lookup(key) {
    var hit = null, family = null;
    for (var i = 0; i < data.length; i++) { if (key.indexOf(data[i].k) === 0) { hit = data[i]; break; } }
    if (hit) {
      for (var j = data.length - 1; j >= 0; j--) {
        if (data[j] !== hit && data[j].k.length < hit.k.length && key.indexOf(data[j].k) === 0 && data[j].n !== hit.n) { family = data[j]; }
      }
    }
    return { hit: hit, family: family };
  }

  // ---------------------------------------------------------------- brand profiles
  var profiles = {};

  profiles.siemens = {
    parse: function (raw) {
      var c = compact(raw), p = c;
      if (/^[0-9][A-Z]{2}[0-9A-Z]/.test(c) && c.length >= 8) {
        p = c.slice(0, 7) + (c.length > 7 ? '-' + c.slice(7, 12) : '') + (c.length > 12 ? '-' + c.slice(12, 16) : '') + (c.length > 16 ? '-' + c.slice(16) : '');
      }
      return {
        key: c,
        valid: /^[0-9][A-Z]{2}[0-9]/.test(c),
        forms: [['Standard form', p], ['As printed on nameplates', p.length > 4 ? p.slice(0, 4) + ' ' + p.slice(4) : p], ['Without separators', c]],
        queries: [p],
        exact: c,
        catalog: /^[0-9][A-Z]{2}[0-9]/.test(c) ? ['Exact variant in the Siemens catalogue', 'https://mall.industry.siemens.com/mall/en/WW/Catalog/Product/' + encodeURIComponent(p)] : null
      };
    },
    invalid: 'Siemens order numbers start with a digit and two letters, e.g. 6ES7, 6SL3, 1FK7.'
  };

  profiles.heidenhain = {
    parse: function (raw) {
      var t = tidy(raw).replace(/^(ID\.?\s*NR\.?|IDNR|ID)\s*[:.]?\s*/, '');
      var c = compact(t);
      // ID numbers: 6 digits + a 2-character variant, written 311262-01, 311 262-01 or 31126201.
      if (/^\d{6}[0-9A-Z]{2}$/.test(c)) {
        var dash = c.slice(0, 6) + '-' + c.slice(6), spaced = c.slice(0, 3) + ' ' + c.slice(3, 6) + '-' + c.slice(6);
        return {
          key: c, valid: true, forced: {
            g: 'Heidenhain ID number', n: 'Exact order number (ID)',
            d: 'An ID number points to one exact variant (interface, line count, cable, connector). It does not describe the product by itself: the model name, e.g. ROD 426 or LS 486C, is printed on the same label.'
          },
          forms: [['Standard form', dash], ['Also written', spaced], ['Without separators', c]],
          queries: [dash, spaced], exact: c, details: []
        };
      }
      // Model designations: letters, then the model number, then optional letters and values.
      var m = t.match(/^([A-Z]{1,7}(?:[ .-]?[A-Z]{2,3})?)[ .-]?(\d{2,5})?\s*([A-Z])?\b[ .-]*(\d{3,6})?/);
      var details = [], query = t;
      if (m) {
        var fam = m[1].replace(/[ .-]/g, ' '), model = m[2], letter = m[3], count = m[4];
        if (model) query = fam + ' ' + model;
        if (model) details.push(['Model', fam + ' ' + model + (letter || '')]);
        if (letter === 'C' && /^(AE )?(LS|LB|LF|RON|ERA|ROD|LC)/.test(fam)) details.push(['Suffix C', 'Distance-coded reference marks']);
        if (count && /^(ROD|ERN|RON|ERA|ERM)$/.test(fam)) details.push(['Line count', count + ' lines per revolution (signal periods)']);
      }
      return {
        key: c, valid: /^[A-Z][A-Z .-]{0,10}\d/.test(t),
        forms: [['As entered', t], ['Without separators', c]],
        queries: [query], exact: compact(query), details: details
      };
    },
    invalid: 'Enter a Heidenhain model name (e.g. ROD 426, LS 486C, ND 780) or an ID number (e.g. 311262-01).'
  };

  profiles.fanuc = {
    parse: function (raw) {
      var t = tidy(raw), hash = '';
      if (t.indexOf('#') !== -1) { hash = t.split('#').slice(1).join('#').replace(/\s+/g, ''); t = t.split('#')[0]; }
      var c = compact(t);
      var p = /^A[0-9]{2}[0-9A-Z]/.test(c) && c.length > 4 ? c.slice(0, 4) + '-' + c.slice(4, 8) + (c.length > 8 ? '-' + c.slice(8) : '') : c;
      var full = p + (hash ? '#' + hash : '');
      var details = [];
      if (hash) details.push(['Suffix #' + hash, 'Variant / specification code. For a direct swap the suffix should match (ask us if yours differs).']);
      return {
        key: c, valid: /^A[0-9]{2}[0-9A-Z]/.test(c),
        forms: [['Standard form', full], ['Without separators', c + (hash ? '#' + hash : '')]],
        queries: [p], exact: c, details: details
      };
    },
    invalid: 'Fanuc part numbers start with A plus three characters, e.g. A06B-6114-H104, A20B-2100-0761, A860-0360-T001.'
  };

  var ATV_KW = { '018': 0.18, '037': 0.37, '055': 0.55, '075': 0.75, U02: 0.18, U04: 0.37, U06: 0.55, U07: 0.75, U09: 0.9, U11: 1.1, U15: 1.5, U22: 2.2, U30: 3, U40: 4, U55: 5.5, U75: 7.5,
    D11: 11, D15: 15, D18: 18.5, D22: 22, D30: 30, D37: 37, D45: 45, D55: 55, D75: 75, D90: 90, C11: 110, C13: 132, C16: 160, C20: 200, C25: 250, C31: 315, C40: 400, C50: 500, C63: 630 };
  var ATV_V = { M2: '200–240 V single-phase supply', M3: '200–240 V three-phase supply', N4: '380–480 V three-phase supply', S6: '525–600 V three-phase supply', Y: '500–690 V three-phase supply' };
  profiles.schneider = {
    parse: function (raw) {
      var c = compact(raw), key = c;
      if (/^TSX140/.test(c)) key = c.slice(3); // Quantum modules are sometimes listed with a TSX prefix
      var details = [];
      var a = c.match(/^ATV(\d{2,3})(H|E)?(\d{3}|[UDC]\d{2})(M2|M3|N4|S6|Y)?([A-Z0-9]*)$/);
      if (a) {
        details.push(['Range', 'Altivar ' + a[1]]);
        if (ATV_KW[a[3]]) details.push(['Motor power', ATV_KW[a[3]] + ' kW']);
        if (a[4] && ATV_V[a[4]]) details.push(['Supply', ATV_V[a[4]]]);
        if (/^320/.test(a[1]) && /^B/.test(a[5])) details.push(['Suffix B', 'Book format']);
        if (/^320/.test(a[1]) && /^C/.test(a[5])) details.push(['Suffix C', 'Compact format']);
        if (/^(61|71)$/.test(a[1]) && /Z$/.test(a[5])) details.push(['Suffix Z', 'Version without integrated EMC filter']);
      }
      return {
        key: key, valid: /^[A-Z0-9]{4,}/.test(c),
        forms: [['Catalogue reference', c], ['As entered', tidy(raw)]],
        queries: [c, tidy(raw)], exact: c, details: details,
        catalog: ['Product page on se.com', 'https://www.se.com/ww/en/product/' + encodeURIComponent(c) + '/']
      };
    },
    invalid: 'Enter a Schneider / Telemecanique / Modicon reference, e.g. 140CPU43412A, TSXP57303AMR, ATV320U15N4B.'
  };

  profiles.rexroth = {
    parse: function (raw) {
      var t = tidy(raw), c = compact(t), details = [];
      if (/^R911\d{6}$/.test(c)) {
        return {
          key: c, valid: true, forced: {
            g: 'Rexroth material number', n: 'Material number (MNR)',
            d: 'R911… numbers identify one exact Rexroth electric drives item. They are printed as "MNR" on the type plate, next to the type code (e.g. HCS02.1E-W0028-…).'
          },
          forms: [['Material number', c]], queries: [c], exact: c, details: []
        };
      }
      var m;
      if ((m = c.match(/^HCS\d{2}\d?[A-Z]?W(\d{4})/)) || (m = t.match(/^HC[SQ]\S*-W(\d{4})/))) details.push(['Current class', parseInt(m[1], 10) + ' A']);
      if ((m = t.match(/^DKC\d{2}\.\d-(\d{3})/))) details.push(['Current class', parseInt(m[1], 10) + ' A']);
      if ((m = t.match(/^H(VR|VE|MV)\S*-W(\d{3})/))) details.push(['Power class', parseInt(m[2], 10) + ' kW']);
      if ((m = t.match(/^TDM \d\.\d-(\d{2,3})-/))) details.push(['Current class', parseInt(m[1], 10) + ' A']);
      if ((m = c.match(/^(MKD|MHD|MSK|MAD|MAF|MKE|MSM|MSS|2AD|1MB)(\d{3})([A-Z])/))) { details.push(['Frame size', m[2]]); details.push(['Length', m[3]]); }
      return {
        key: c, valid: /^[A-Z0-9]{3,}/.test(c),
        forms: [['Type code', t], ['Without separators', c]],
        queries: [t.split('-')[0], t], exact: c, details: details
      };
    },
    invalid: 'Enter a Rexroth / Indramat type code (e.g. HCS02.1E-W0028, DKC01.3-040-7-FW, MKD090B) or a material number (R911…).'
  };

  var profile = profiles[brand];
  if (!profile) return;

  // ---------------------------------------------------------------- UI
  var form = document.getElementById('spdForm'), input = document.getElementById('spdInput'), out = document.getElementById('spdResult');

  function decode(raw) {
    if (!String(raw || '').trim()) { out.hidden = true; return; }
    var r = profile.parse(raw);
    var found = r.forced ? { hit: r.forced, family: null } : lookup(r.key);
    var hit = found.hit, html = '';
    if (hit) {
      html += '<p class="spd-r-label">' + esc(hit.g) + '</p><h2 class="spd-r-title">' + esc(hit.n) + '</h2><p class="spd-r-desc">' + esc(hit.d) + '</p>';
      if (found.family) html += '<p class="spd-r-meta">Part of: ' + esc(found.family.n) + '</p>';
    } else if (r.valid) {
      html += '<h2 class="spd-r-title">Not in our prefix list yet</h2><p class="spd-r-desc">We can\'t place this one in a product family, but we can still check our stock and sourcing for it.</p>';
    } else {
      html += '<h2 class="spd-r-title">That doesn\'t look like a valid number</h2><p class="spd-r-desc">' + esc(profile.invalid) + ' For other brands, use the part search at the top of the page.</p>';
    }
    if (r.details && r.details.length) {
      html += '<dl class="spd-r-details">' + r.details.map(function (d) { return '<div><dt>' + esc(d[0]) + '</dt><dd>' + esc(d[1]) + '</dd></div>'; }).join('') + '</dl>';
    }
    if (hit || r.valid) html += '<dl class="spd-r-forms">' + r.forms.map(function (f) { return '<div><dt>' + esc(f[0]) + '</dt><dd><code>' + esc(f[1]) + '</code></dd></div>'; }).join('') + '</dl>';
    if (r.catalog && r.valid) html += '<p class="spd-r-links"><a href="' + esc(r.catalog[1]) + '" target="_blank" rel="noopener nofollow">' + esc(r.catalog[0]) + ' ↗</a></p>';
    html += '<div class="spd-r-stock" id="spdStock"><p class="spd-r-meta">Checking our stock…</p></div>';
    out.innerHTML = html; out.hidden = false;
    stock(r);
  }

  function stock(r) {
    var box = document.getElementById('spdStock');
    var queries = r.queries.filter(function (q, i, a) { return q && a.indexOf(q) === i; }).slice(0, 2);
    Promise.all(queries.map(function (q) {
      return fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
        .then(function (res) { return res.json(); })
        .then(function (d) { return (((d || {}).resources || {}).results || {}).products || []; })
        .catch(function () { return []; });
    })).then(function (lists) {
      var seen = {}, items = [];
      lists.forEach(function (l) { l.forEach(function (it) { var u = it.url.split('?')[0]; if (!seen[u]) { seen[u] = 1; it.url = u; items.push(it); } }); });
      return Promise.all(items.map(function (it) {
        if (r.exact && compact(it.title).indexOf(r.exact) !== -1) { it.exact = true; return it; }
        // Part numbers often live in tags / SKU rather than the title: check the product itself.
        return fetch(it.url + '.js').then(function (res) { return res.json(); }).then(function (pr) {
          var hay = [pr.title, String(pr.description || '').replace(/<[^>]+>/g, ' ')].concat(pr.tags || [], (pr.variants || []).map(function (v) { return v.sku; })).map(compact);
          it.exact = !!r.exact && hay.some(function (h) { return h && h.indexOf(r.exact) !== -1; });
          return it;
        }).catch(function () { return it; });
      }));
    }).then(function (items) {
      var exact = items.filter(function (it) { return it.exact; });
      var related = items.filter(function (it) { return !it.exact; }).slice(0, 4);
      var li = function (it) { return '<li><a href="' + esc(it.url) + '">' + esc(it.title) + '</a>' + (it.price ? ' <span>€' + esc(it.price) + '</span>' : '') + '</li>'; };
      var html = '';
      if (exact.length) html += '<h3 class="spd-r-sub">In stock at Samonde</h3><ul class="spd-r-list">' + exact.map(li).join('') + '</ul>';
      else html += '<p class="spd-r-meta">We don\'t have this exact number listed right now. <a href="/pages/contact">Send us a sourcing request</a>, since we often find parts that aren\'t listed.</p>';
      if (related.length) html += '<h3 class="spd-r-sub">Similar parts we stock</h3><ul class="spd-r-list">' + related.map(li).join('') + '</ul>';
      html += '<p class="spd-r-meta"><a href="/search?type=product&q=' + encodeURIComponent(queries[0] || '') + '">Search all our stock for ' + esc(queries[0] || '') + ' →</a></p>';
      box.innerHTML = html;
    });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    decode(input.value);
    try { var u = new URL(location.href); u.searchParams.set('pn', input.value.trim()); history.replaceState(null, '', u); } catch (err) {}
    if (typeof gtag !== 'undefined') gtag('event', 'part_decode', { event_category: 'tool', event_label: brand + ':' + compact(input.value) });
  });
  Array.prototype.forEach.call(document.querySelectorAll('.spd-ex'), function (b) {
    b.addEventListener('click', function () { input.value = b.getAttribute('data-pn'); decode(input.value); });
  });
  var start = new URLSearchParams(location.search).get('pn');
  if (start) { input.value = start; decode(start); }
})();
